export default __webpack_public_path__ + "static/media/SUD.5b510660.svg";